import React, { useState } from 'react';
import { menuData } from '../data/menuData';

const MenuSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Wszystkie' },
    { id: 'kebab-bulka', name: 'Kebab w Bułce' },
    { id: 'lawasz', name: 'Lawasz (Tortilla)' },
    { id: 'pita', name: 'Pita Turecka' },
    { id: 'kebab-box', name: 'Kebab Box' },
    { id: 'kapsalon', name: 'Kapsalon' },
    { id: 'kanapki', name: 'Kanapki' },
    { id: 'zestawy', name: 'Zestawy i Menu dla Dzieci' },
    { id: 'dodatki', name: 'Dodatki' },
    { id: 'napoje', name: 'Napoje' },
  ];

  const filteredMenu =
    selectedCategory === 'all'
      ? menuData
      : menuData.filter((category) => category.id === selectedCategory);

  return (
    <section id="menu" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12">
          <span className="text-red-500">Nasze Menu</span>
        </h2>

        {/* Category filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap sm:justify-center gap-3 w-full sm:w-auto px-4 sm:px-0">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-4 py-3 rounded-full font-semibold transition-all duration-200 text-sm ${
                  selectedCategory === category.id
                    ? 'bg-red-500 text-white shadow-lg transform scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-100 shadow'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Menu items */}
        <div className="space-y-16">
          {filteredMenu.map((category) => (
            <div key={category.id}>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">{category.name}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.items.map((item, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
                  >
                    <div className="flex justify-between items-start mb-3">
                      <h4 className="text-xl font-bold text-gray-800 flex-1">{item.name}</h4>
                      <span className="text-2xl font-bold text-red-500 ml-2">{item.price}</span>
                    </div>
                    {item.description && (
                      <p className="text-gray-600 text-sm">{item.description}</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
